import '../index_mWeb.css';
import FlatList from 'flatlist-react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import {
  EmptyData,
  ErrorMessage,
  FlatListWrapper,
  PlaceHolder,
  View,
  PaginationIndicator,
  TransactionGameItem,
  TransactionHeaderGameItem
} from '../../../../component';

const GameHistoryMWeb = ({
  error,
  resultArrived,
  _onRefresh,
  hasMoreItems,
  loadMoreItems,
  gameTransactionList,
  onPressRetryGame
}: any) => {
  const renderItemGame = (item: any) => <TransactionGameItem item={item} />;
  const renderSectionItem = (item: any) => {
    const { header = {}, data = [] } = item;
    return (
      <View
        style={{
          width: '100%',
          backgroundColor: '#252e3b',
          padding: '10px 0px',
          border: '0.5px solid #fff',
          margin: '10px 0px'
        }}>
        <FlatList renderOnScroll renderItem={renderItemGame} list={data} />
        <TransactionHeaderGameItem item={header} />
      </View>
    );
  };

  const renderWhenEmpty = () => {
    if (error) return <ErrorMessage onPressRetry={onPressRetryGame} />;
    if (!resultArrived) return <PlaceHolder.Loader />;
    return <EmptyData message={'No Games Transaction found'} />;
  };

  return (
    <View className={'transaction-history-container'}>
      <PullToRefresh onRefresh={_onRefresh}>
        <FlatListWrapper>
          <FlatList
            renderItem={renderSectionItem}
            list={gameTransactionList}
            renderWhenEmpty={renderWhenEmpty}
            hasMoreItems={hasMoreItems}
            loadMoreItems={loadMoreItems}
            // renderOnScroll
            paginationLoadingIndicator={<PaginationIndicator />}
          />
        </FlatListWrapper>
      </PullToRefresh>
    </View>
  );
};
export default GameHistoryMWeb;
